import { Navigate, useLocation, useRoutes } from 'react-router-dom';
import DashboardLayout from './layouts/dashboard';
import DashboardApp from './pages/DashboardApp';
import ReportApp from './pages/ReportApp';
import DatasetsApp from './pages/DatasetsApp';
import ExternalReport from './pages/ExternalReport';
import GetUserInfo from './pages/externalReports/GetUserInfo';
import Favourites from './pages/Favourites';
import NotFound from './pages/NotFound';
import NotAuthorised from './pages/NotAuthorised';
import ReportLayout from './layouts/report';
import AuthService from './utils/AuthService';
import ReportDashboardLayout from './layouts/reportDashboard';
import PublishedDashboard from './layouts/publishedDashboard';
import DashboardView from './layouts/dashboardView';
import QuickSightDash from './pages/QuickSightDash';
import SetUsername from './pages/SetUsername';
import UserType from './pages/UserType';
import Role from './pages/Role';
import JoinModule from './pages/JoinModule'
import SetCredentials from './pages/SetCredentials';
import Login from './pages/Login';
import ReportFolderApp from './pages/ReportFolderApp';
import ReportView from './layouts/report/ReportView'
import RouteAuthService from './utils/RouteAuthService';
import Logout from './pages/Logout';
import ChartDashboardV2 from './pages/ChartDashboardV2/ChartDashboardV2';
import ChartDashboardV3 from './pages/ChartDashboardV3/ChartDashboardV3';
import SetLanguage from './pages/SetLanguage';
import DataSource from './pages/DataSource';
import UserManagement from './pages/UserManagement';
import CalculatedFields from './pages/CalculatedFields';
import ManageDataset from './components/_datasets/tables/ManageDataset'
import AdminLogin from './pages/AdminLogin';
import Settings from './pages/Settings';
import PublishedDashboardList from './pages/PublishedDashboardList'
import { DecryptData } from './utils/encryptDecrypt';
import Preagg from './pages/Preagg';
import CubeSocket from './pages/CubeSocket';
import { IconApp } from './pages/IconApp';
import ReportNew from './pages/ReportNew';
import AddAlertForm from './pages/reportScheduler/AddAlertForm';
import AlertList from './pages/reportScheduler/AlertList';
import CrmDashboard from './pages/CustomDashboards/CrmDashboard';
import Download from './pages/Download';
import ReportDashboardNewLayout from './layouts/reportDashboardNew';
import DownloadReports from './pages/DownloadReports';

export default function Router() {
  const location = useLocation();
  //console.log(location)
  let loginPath = DecryptData(localStorage.getItem('loginSource'))
  loginPath = loginPath ? `/${loginPath}`:null

  return useRoutes([
    {
      path: '/',
      element: AuthService().authorised ? <DashboardLayout /> : <Navigate to={loginPath ?? "/adminLogin"} replace state={{ from: location }}/>,
      children: [
        { path: '/', element: <Navigate to="/adminLogin" replace /> },
        { path: 'dashboard', element: RouteAuthService({ route: 'dashboard', component: <DashboardApp /> }) },
        { path: "report", element: RouteAuthService({ route: 'report', component: <ReportApp /> }) },        
        { path: "report-view/:id", element: <ReportView /> },
        { path: "report/report-folder-view/:id", element: <ReportFolderApp /> },
        { path: "datasets", element: RouteAuthService({ route: 'datasets', component: <DatasetsApp /> }) },
        { path: "icons", element: RouteAuthService({ route: 'icons', component: <IconApp /> }) },
        { path: "favourites", element: RouteAuthService({ route: 'favourites', component: <Favourites /> }) },
        { path: "usertype", element: RouteAuthService({ route: 'usertype', component: <UserType /> }) },
        { path: "role", element: RouteAuthService({ route: 'role', component: <Role /> }) },
        { path: '/dataset/:id/prepare', element: <JoinModule /> },
        { path: "dataSource", element: RouteAuthService({ route: 'dataSource', component: <DataSource /> }) },
        { path: "preAggregation", element: RouteAuthService({ route: 'preAggregation', component: <Preagg /> }) },
        { path: "calculatedFields", element: RouteAuthService({ route: 'calculatedFields', component: <CalculatedFields /> }) },
        { path: "userManagement", element: RouteAuthService({ route: 'userManagement', component: <UserManagement /> }) },
        {
          path: '/settings', element: RouteAuthService({ route: 'settings', component: <Settings /> }) 
        },
        {
          path: '/publishedDashboardList', element: RouteAuthService({ route: 'publishedDashboardList', component: <PublishedDashboardList /> })
        },
        { path: '/manageDataset/:datasetId', element: RouteAuthService({ route: 'manageDataset', component: <ManageDataset /> })  },

        { path: '/addAlert', element: <AddAlertForm /> },
        { path: '/updateAlert/:id', element: <AddAlertForm /> },
        { path: '/alertList', element: RouteAuthService({ route: 'alertList', component: <AlertList /> })},
        { path: '/downloadReports', element: RouteAuthService({ route: 'downloadReports', component: <DownloadReports /> })}
      ]
    },
    { path: "404", element: <NotFound /> },
    { path: "/readyz", element: <NotFound />},
    { path: "/healthz", element: <NotFound />},
    { path:'reportNew',element: AuthService().authorised ? <ReportNew /> : <Navigate to={loginPath ?? "/adminLogin"} replace state={{ from: location }}/>},
    {
      path: '/reportDashboardNew/:id',
      element: AuthService().authorised ? <ReportDashboardNewLayout /> : <Navigate to={loginPath ?? "/adminLogin"} replace state={{ from: location }}/>,
    },
    {
      path: '/reportDashboard/:id',
      element: AuthService().authorised ? <ReportDashboardLayout /> : <Navigate to={loginPath ?? "/adminLogin"} replace state={{ from: location }}/>,
    },
    {
      path: '/reportGraph/:id',
      element: AuthService().authorised ? <ReportLayout /> : <Navigate to={loginPath ?? "/adminLogin"} replace state={{ from: location }}/>,
    },
    {
      path: '/embedDashboard/:id',
      element: <PublishedDashboard />
    },
    {
      path: '/dashboardView/:id',
      element: AuthService().authorised ? <DashboardView /> : <Navigate to={loginPath ?? "/adminLogin"} replace state={{ from: location }}/>
    },
    {
      path: '/dashboardView/preview',
      element: AuthService().authorised ? <DashboardView /> : <Navigate to={loginPath ?? "/adminLogin"} replace state={{ from: location }}/>
    },
    {
      path: '/quickDash',
      element: <QuickSightDash />
    },
    {
      path: '/studentReport',
      element: AuthService().authorised ? <ChartDashboardV2 /> : <Navigate to="/unauthorised" replace state={{ from: location }}/>
    },
    {
      path: '/crm-dashboard',
      element: AuthService().authorised ? <CrmDashboard /> : <Navigate to="/unauthorised" replace state={{ from: location }}/>
    },
    {
      path: '/setusername/:id',
      element: <SetUsername />
    },
    {
      path: '/setcreds/:id',
      element: <SetCredentials />
    },
    {
      path: '/download/:p1/:p2',
      element: <Download />
    },
    // {
    //   path: '/manageDataset/:datasetId',
    //   element: <ManageDataset />
    // },

    {
      path: '/setLanguage',
      element: <SetLanguage />
    },
    {
      path: '/login',
      element: AuthService().authorised ? <Navigate to="/dashboard" replace /> : <Login />,
    },
    {
      path: '/adminLogin',
      element: AuthService().authorised ? <Navigate to="/dashboard" replace /> : <AdminLogin />,
    },
    {
      path: '/unauthorised',
      element: <NotAuthorised isOpen={true} />
    },
    {
      path: '/logout',
      element: <Logout />
    },
    {
      path: '/externalReport',
      element: <ExternalReport />
    },
    {
      path: '/getUserInfoByUuid',
      element: <GetUserInfo />
    },
    {
      path: '/cubeSocket',
      element: <CubeSocket />
    },
    {
      path: '/studentReportV3',
      element: AuthService().authorised ? <ChartDashboardV3 /> : <Navigate to="/unauthorised" replace state={{ from: location }}/>
    },
    // {
    //   path: '/dataBlending',
    //   element: AuthService().authorised ? <DataBlending /> : <Navigate to="/unauthorised" replace />
    // },
    { path: '*', element: <Navigate to="/404" replace /> },


  ]);
}




